<template>
	<div class="createorder" ref="createorder">
		<el-form ref="createorderform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<rate ref="rate" @formScrollTop="formScrollTop" @cancel="cancel"></rate>
		</el-form>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import rate from '@/components/order/createorder_rate.vue';
export default {
	components: {
		rate
	},
	props: {},
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			pmodelist: [],
			divclass: 'createorder',
			syscol: '',
			t_id: 'rate_1',
			p_mode_remark: '',
			checkedpmode: '报价',
			orderinfo: {p_mode:'报价'},
			p_pkval: ''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/createorder.scss');
		});
	},
	methods: {
		init(param) {
			this.GetPageLayout();
		},
		GetPageLayout() {
			var that = this;
			this.truncatepage();
			if (this.checkedpmode != '') {
				//判断是哪种类型的下单功能,显示对应组件
				this.$apipost.get.GetTransFormat({ p_mode: this.orderinfo.p_mode }).then(res => {
					if (res.state == '1') {
						if (res.set != undefined) {
							that.t_id = res.set.t_id;
							if (res.set.t_type == '报价')
								that.$refs.rate.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});
							else {
							}
						}
					}
				});
			}
		},
		//滚动条滚动到顶部
		formScrollTop() {
			this.$nextTick(() => {
				this.$refs.createorderform.$el.scrollTop = this.$refs.createorderform.$el.scrollHeight;
			});
		},
		//初始化页面
		truncatepage() {
			if (this.$refs.rate != undefined) this.$refs.rate.isload = false;
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
};
</script>

<style></style>
